import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import "./ProductImageSlider.css";

function ProductImageSlider({ images = [], onImageClick }) {
  const canLoop = images.length > 1;
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: canLoop,
    align: "center",
    containScroll: false,
    skipSnaps: false,
    duration: 25,
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return undefined;

    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.reInit({
      loop: images.length > 1,
      align: "center",
      containScroll: false,
    });
    emblaApi.scrollTo(0, true);
  }, [emblaApi, images]);

  if (!images.length) return null;

  return (
    <div className="product-image-slider">
      <div className="product-image-slider__viewport" ref={emblaRef}>
        <div className="product-image-slider__container">
          {images.map((image, index) => (
            <div className="product-image-slider__slide" key={image?.url || index}>
              <button
                type="button"
                className="product-image-slider__card"
                onClick={() => onImageClick?.(image?.url)}
                aria-label={`View product image ${index + 1}`}
              >
                <div className="home-img">
                  <img
                    src={image?.url}
                    className="img-fluid bg-img"
                    alt=""
                    draggable={false}
                  />
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      {canLoop && (
        <div className="product-image-slider__dots">
          {images.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`product-image-slider__dot${
                index === selectedIndex
                  ? " product-image-slider__dot--active"
                  : ""
              }`}
              aria-label={`Go to image ${index + 1}`}
              aria-current={index === selectedIndex ? "true" : undefined}
              onClick={() => emblaApi?.scrollTo(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ProductImageSlider;
